function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.589 2.068a3.695 3.695 0 00-5.19-.003l-8.842 8.84A5.372 5.372 0 001 14.696v8.638A3.664 3.664 0 004.667 27h18.666A3.675 3.675 0 0027 23.333v-8.637a5.388 5.388 0 00-1.574-3.79L16.59 2.068z",
  fillRule: "nonzero",
  stroke: "#5D5D5D",
  strokeWidth: 2,
  fill: "none"
});

function SvgHomeOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgHomeOff;